export class RepresentadoVO {

  idRepresentacao: number;
  nomeRepresentante: string;
  siglaSistema: string;

}
